import { Stack, Text } from "@mantine/core";
import { HeldEmailActionConfirmModel } from "./heldEmailActionConfirmModel";
import { HeldEmailConfirmButtons } from "./HeldEmailConfirmButtons";

export function HeldEmailActionConfirmContent({
  model,
}: {
  model: HeldEmailActionConfirmModel;
}) {
  return (
    <Stack>
      <Text>{model.message}</Text>
      <HeldEmailConfirmButtons
        actionLabel={model.actionLabel}
        cancelLabel={model.cancelLabel}
        color={model.color}
        loading={model.loading}
        onClose={model.onClose}
        onConfirm={model.onConfirm}
      />
    </Stack>
  );
}
